import { render, staticRenderFns } from "./timedsalegoodslist.vue?vue&type=template&id=63fd8e7f&scoped=true"
import script from "./timedsalegoodslist.vue?vue&type=script&lang=js"
export * from "./timedsalegoodslist.vue?vue&type=script&lang=js"
import style0 from "./timedsalegoodslist.vue?vue&type=style&index=0&id=63fd8e7f&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fd8e7f",
  null
  
)

export default component.exports